import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["target", `color-${ _ctx.target.colorId }`]),
    onClick: _ctx.commitCandidate,
    style: _normalizeStyle(`grid-area: ${_ctx.target.block.y+1}/${_ctx.target.block.x+1}/${_ctx.blockYEnd(_ctx.target.block)+1}/${_ctx.blockXEnd(_ctx.target.block)+1}`)
  }, null, 14 /* CLASS, STYLE, PROPS */, ["onClick"]))
}